import { useQuery } from '@tanstack/react-query'
import { describe } from 'app/services/sfAuth/sfData/sfSurvey'

/**
 * Retrieves the available contact "Roles" types from Salesforce.
 * @function
 * @category Salesforce - Contact
 * @returns {object[]}
 */
export const getContactRoleValues: () => Promise<object[]> = async () => {
  const result = await describe('Opportunity_Affiliation__c')
  const contactTypes = result?.fieldsMap?.Role__c?.picklistValues
    .filter((field) => field.active)
    .map((field) => {
      return {
        label: field.label,
        value: field.value
      }
    })
  return contactTypes
}

export const useContactRoleValues: (lang: string) => object[] | undefined = (lang) => {
  const { data } = useQuery({
    queryKey: ['contactRoles', lang],
    queryFn: async () => await getContactRoleValues(),
    staleTime: 5 * 60 * 1000
  })
  return data
}
